class Registre  {
    constructor(
        public id = 0,
        public key= 0,
        public id_usuari =0,
        public moment= "",
        public latitude = null,
        public longitude = null,
        public registre ="",
        public tipus= 0,
        public lloc= "",
    ){
        this.id = id;
        this.key = key;
        this.id_usuari = id_usuari;
        this.moment = moment;
        this.latitude= latitude;
        this.longitude = longitude;
        this.tipus = tipus;
        this.lloc = lloc;

    }
}
export default Registre
